<template>
  <span class="text-no-wrap">
    <v-icon :class="projectStatus.class" class="mr-2">{{ projectStatus.icon }}</v-icon>
    <span :class="projectStatus.class">{{ projectStatus.name }}</span>
  </span>
</template>


<script>
import projectStatusMixin from '@/mixins/projectStatus.mixin'


export default {
  mixins: [projectStatusMixin],


  props: {
    value: {
      type: Number
    }
  },


  computed: {
    projectStatus () {
      return this.getProjectStatusById(this.value)
    }
  }
}
</script>
